<template>
  <div>
    <v-row no-gutters class="mb-7">
      <h3 v-if="resultSign.message" class="result--blue mr-8 result">Результат проверки:</h3>
      <div class="d-flex align-center">
        <v-icon :color="resultSign.color" class="mr-2">{{ resultSign.icon }}</v-icon>
        <span class="result" :class="resultSign.signValid ? 'result--green' : 'result--red'">
          {{ resultSign.message }}
        </span>
      </div>
    </v-row>
    <v-row no-gutters v-if="resultSign.visible">
      <v-col>
        <v-card elevation="5">
          <v-data-table
            :headers="headers"
            :items="signInfo"
            hide-default-footer
            style="border-bottom: 1px solid #e0e0e0;"
            no-data-text="Нет результатов для отображения"
            loading-text="Загрузка..."
          >
            <template v-slot:item="{ item, index }">
              <tr style="height: 60px;">
                <td>{{ index + 1 }}</td>
                <td class="py-2">
                  <div>{{ item.organisationInn }}</div>
                  <div class="cell-text">{{ item.organizationName }}</div>
                </td>
                <td class="py-2">
                  <div>{{ item.inn }}</div>
                  <div class="cell-text">{{ item.fullName }}</div>
                </td>
                <td class="cell-text">
                  {{
                    moment
                      .unix(item.timestamp)
                      .utc()
                      .format('LLL')
                  }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'Results',
  props: {
    resultSign: {
      type: Object,
      default: () => {}
    },
    signInfo: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    headers: [
      { text: '№', sortable: false },
      { text: 'Организация', align: 'left', sortable: false },
      { text: 'Сотрудник', align: 'left', sortable: false },
      { text: 'Дата и время подписи', align: 'left', sortable: false }
    ]
  })
}
</script>

<style scoped lang="scss">
.result {
  font-weight: 600;
  font-size: 20px;
  line-height: 27px;
  &--blue {
    color: #007aff;
  }
  &--green {
    color: #50bf34;
  }
  &--red {
    color: #ff0000;
  }
}
.cell-text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #333;
}
</style>
